import React from "react";
import schoolImage from "./assests/schoolImage.png";
import Image from "./assests/IMAGE(D).png";
import Director from "./assests/Director.png";
import "../style/directorMessage.css";

const SchoolDescription = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <div>
            <img src={Image} alt="heroImage" />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-7 col-md-6 col-sm-12 mr-16 mt-20">
          <h1
            style={{
              fontWeight: "bold",
              color: "#8C1F1F",
              fontSize: "2rem",
              lineHeight: "40px",
            }}
          >
            DR. LAKHBIR KAUR VERMA
          </h1>
          <h2
            style={{
              fontWeight: "bold",
              color: "#8C1F1F",
              lineHeight: "35px",
              fontSize: "1.2rem",
            }}
          >
            DIRECTOR
          </h2>
          <p className="mt-6 text-lg text-black  leading-7">
            Ever since I have been entrusted with the responsibility of
            stewarding the Guru Harkrishan High School & Jr. College of
            Commerce, I have taken it up as a divine dictate and committed
            myself to fulfill my obligations to Guru Harkrishan Education
            Society and the trust with which I have been empowered to fulfill my
            duties and always remind myself of the magnitude of responsibility
            that an educational institution has to shoulder. The purpose of an
            educational institution is not only to teach academic subjects but
            to ensure the holistic development of the pupils and prepare them to
            shoulder responsibilities as a house holder, as a helpful neighbour,
            a co-operative colleague, a patriotic citizen and as a magnanimous,
            tolerant member of the entire human race. It is the responsibility
            of the institution to make its pupils sensitive and appreciative of
            the environment and the wonderful creation of God in the form of
            murmuring rivers & rivulets, echoing vales and dales, and the
            roaring waves of the mighty sea and the vast canopy of the sky over
            our heads.
          </p>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12 mt-10">
          <div class="DirectorimageDiv">
            <img src={Director} class="DirectorImage1" />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 w-[1220px]">
          <p className="mt-10 text-lg  text-black leading-7">
            This unfeeling, unemotional, unaesthetic and indifferent attitude of
            the modern human society was lamented for by D.H. Lawrence when he
            exclaimed "For God's sake let us be men and not monkeys, minding
            machines". Today as never before the educational institutions are
            facing more challenges from diverse distracting factors which are
            influencing the impressionable minds of the students and diverting
            them towards dissipating and devastating pastime and pleasure pecked
            activities. In this present scenario, we at Guru Harkrishan High
            School & Jr. College of Commerce strive to bridge most of the gaps
            between the teacher and the taught with affection, patience and
            persuasion. We believe that even the hardcore deviants and
            defaulters can be won over by affectionate and human touch. This is
            the most formidable challenge which needs to be tackled most
            tactfully. It becomes the responsibility and the duty of the
            educationist to ensure that our Students are weaned away from all
            types of harmful influences. I must admit that I have been
            singularly fortunate to get the best support and co-operation from
            the managing committee always which has served as a morale booster
            to discharge my duties. I take this opportunity to acknowledge and
            appreciate the co-operation of my management, my teachers, the non-
            teaching and supporting staff and express my gratitude to all the
            parents who all are the pillars of this institution.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SchoolDescription;
